import { Form, Input } from "antd";
// import type { UploadProps } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { useI18n } from "../../contexts/I18nContext";
import { useForm } from "antd/es/form/Form";
import toast from "react-hot-toast";

//发送信息表单组件
const MessageInput = ({ handleSendMessage }) => {
  const [form] = useForm();
  const { formatMessage } = useI18n();
  // const props: UploadProps = {
  //   name: "file",
  //   action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  //   headers: {
  //     authorization: "authorization-text",
  //   },
  //   style: { marginLeft: 8, cursor: "pointer" },
  //   onChange(info) {
  //     if (info.file.status !== "uploading") {
  //       console.log(info.file, info.fileList);
  //     }
  //     if (info.file.status === "done") {
  //       //文件上传成功及发送消息
  //       message.success(`${info.file.name} file uploaded successfully`);
  //     } else if (info.file.status === "error") {
  //       //文件上传失败
  //       message.error(`${info.file.name} file upload failed.`);
  //     }
  //   },
  // };
  return (
    <Form
      layout="inline"
      form={form}
      onFinish={(values) => handleSendMessage(values, form)}
      onFinishFailed={({ errorFields }) => {
        const firstError = errorFields[0]?.errors[0];
        if (firstError) {
          toast.error(firstError);
        }
      }}
      autoComplete="off"
      style={{ alignItems: "center" }}
    >
      <Form.Item
        name="content"
        style={{ flex: 1 }}
        rules={[
          {
            required: true,
            validator: (_, value) => {
              if (!value || value.trim() === "") {
                return Promise.reject(formatMessage("messageCannotBeEmpty"));
              }
              // 自定义验证规则
              if (value && value.length < 2) {
                return Promise.reject(formatMessage("messageTooShort"));
              }
              if (value && value.length > 200) {
                return Promise.reject(formatMessage("messageTooLong"));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input placeholder={formatMessage("placeholderText")} />
      </Form.Item>
      <SendOutlined
        onClick={() => {
          form?.submit();
        }}
      />
      {/* <Upload {...props}>
        <UploadOutlined />
      </Upload> */}
    </Form>
  );
};

export default MessageInput;
